<template>
  <div class="projectRole">
    <div class="role-auth-aside">
      <div key="0" class="role-auth-table">
        <div class="role-auth-bar">
          <el-input v-model="filterText" placeholder="输入关键字进行过滤" size="small" clearable>
            <template #prefix>
              <i class="el-icon-search el-input__icon" />
            </template>
          </el-input>
          <el-dropdown v-if="addPrjRoleUserConfig || addSpecConfig" trigger="click"
            @command="roleCommand">
            <span class="el-dropdown-link" style="cursor: pointer"><i class="el-icon-circle-plus-outline"></i></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="addPrjRoleUserConfig" command="role">
                新增角色
              </el-dropdown-item>
              <el-dropdown-item v-if="addSpecConfig" command="major">
                新增专业
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <roleTree
          ref="roletree"
          :roleType="roleType"
          :curOption="curOption"
          @empty="empty"
          @setRoleTreeData="setRoleTreeData"
          @modellist="modellist"
          @setSystemAddOption="setSystemAddOption"
          @setLoading="setLoading"
        ></roleTree>
      </div>
    </div>
    <!-- 右侧内容区域 -->
    <div class="role-auth-content">
      <div v-if="systemAddOption.roleID && systemAddOption.$isOperation != 1" style="height:100%">
        <template>
          <div style="display: flex;justify-content: space-between;">
            <div class="role-auth-project-top">
              权限分配
            </div>
            <div style="padding-right:var(--big-space)">
              <el-button v-if="systemAddOption.roleName != '系统管理员'" type="default" icon="el-icon-document-copy"
                size="small" @click="copyToOtherSpecRole">
                复制设置到其他角色
              </el-button>
              <el-button v-if="systemAddOption.roleName != '系统管理员'" :disabled="isDisabled" type="primary" size="small"
                @click="submitModulesHandler()">
                提交权限
              </el-button>
            </div>
          </div>
          <div v-loading="tableLoading" class="role-auth-project-list" element-loading-text="数据加载中...">
            <el-table :indent="16" :tree-props="moduleTreeProp" :data="moduleTree" :row-style="rowStyle"
              :show-header="false" :cell-style="cellStyle" :header-cell-style="headerStyle" row-key="permissionId"
              default-expand-all border height="100%">
              <template slot="empty">
                <img :src="zanwu" alt="图片" />
                <p style="font-size:16px;color:#000;">
                  暂无数据
                </p>
              </template>
              <el-table-column class-name="table-module-name" width="260px">
                <template #default="{ row }">
                  <el-checkbox v-model="row.isChecked" :true-label="1" :false-label="0"
                    :indeterminate="getIndeterminate(row)" @change="setTreeLimit(row)">
                    {{ row.permissionName }}
                  </el-checkbox>
                </template>
              </el-table-column>
              <el-table-column class-name="table-module-name">
                <template #default="{ row }">
                  <div v-for="(item, index) in row.buttonList" :key="index" style="margin-right: 30px; width: 150px">
                    <el-checkbox v-model="item.isChecked" :true-label="1" :false-label="0"
                      @change="checkboxChange(item)">
                      {{ item.permissionName }}
                    </el-checkbox>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
      </div>
      <template v-else>
        <div class="empty mt-40">
          请选择左侧角色
        </div>
      </template>
    </div>
    <addSpecDlg ref="addSpecDlg" @ok="getRoleList" />
    <selectProjectRoleDlg ref="selectProjectRoleDlg" :systemAddOption="systemAddOption" @ok="getRoleList" />
    <selectSpecRoleDlg ref="selectSpecRoleDlg" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { disablePrompt, checkPermission } from "@/CommonDP/utils/routeAuth";
import roleTree from '@/CommonDP/pages/mainMg/settings/permission/components/roleTree';
import selectProjectRoleDlg from '@/CommonDP/pages/mainMg/settings/permission/components/selectProjectRoleDlg';
import addSpecDlg from '@/CommonDP/pages/mainMg/settings/permission/addSpecDlg';
import priviService from "@/CommonDP/service/privi-service";
import selectSpecRoleDlg from '@/CommonDP/pages/mainMg/settings/permission/components/selectSpecRoleDlg.vue';
import { getTreeData } from "@/CommonDP/utils/tree";
export default {
  components: {
    roleTree,
    selectProjectRoleDlg,
    addSpecDlg,
    selectSpecRoleDlg
  },
  props: {
    curOption: {
      type: Object,
      default: () => ({
        roleID: "",
        roleName: ""
      })
    }
  },
  data() {
    return {
      filterText: "",
      addPrjRoleUserConfig: checkPermission(this.$allPerms.ROLEPOWERCONFIG_ADD_PRJROLE),
      addSpecConfig: checkPermission(this.$allPerms.ROLEPOWERCONFIG_ADD_SPEC),
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      roleType: 1,
      moduleTree: [],
      tableLoading: false,
      moduleTreeProp: {
        children: "childList"
      },
      systemAddOption: {
        roleID: "",
        $isOperation: "",
        roleName: "",
        pid: "",
        id: ""
      },
      initModuleTree: [] // 右侧初始获得的模块树
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId
    }),
    // 判断是否与原数据发生变化
    isDisabled() {
      return JSON.stringify(this.initModuleTree) === JSON.stringify(this.submitList);
    },
    submitList() {
      const newarr = [];
      this.getTreeDataByFilter(this.moduleTree, newarr);
      return newarr;
    },
    // 扁平化
    flatModuleList() {
      const { moduleTree } = this;
      const list = [];
      const each = childList => {
        for (const module of childList) {
          list.push(module);
          const { childList } = module;
          if (childList && childList.length > 0) each(childList);
        }
      };
      each(moduleTree);
      return list;
    }
  },
  watch: {
    filterText(val) {
      this.$refs.roletree.filterText(val);
    }
  },
  methods: {
    // 添加项目角色
    async roleCommand(command) {
      const a = disablePrompt();
      if (a) {
        if (command === "major") {
          this.$refs.addSpecDlg.showDlg();
        } else {
          this.$refs.selectProjectRoleDlg.showDlg();
        }
      }
    },
    // 获取模块
    modellist(roleID) {
      this.tableLoading = true;
      const params = {
        roleId: roleID,
        businessType: this.roleType,
        enterpriseId: this.enterpriseId
      };
      priviService.queryPermissionTreeForEnterpriseCheck(params).then(({ data }) => {
        this.moduleTree = data || [];
        getTreeData(this.moduleTree);
        this.tableLoading = false;
        var list = [];
        this.getTreeDataByFilter(this.moduleTree, list);
        this.initModuleTree = JSON.parse(JSON.stringify(list));
      });
    },
    getTreeDataByFilter(data, newarr) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].isChecked === 1) {
          newarr.push({
            permissionId: data[i].permissionId,
            isParentPage: data[i].isParentPage
          });
        }
        if (data[i].childList && data[i].childList.length > 0) {
          this.getTreeDataByFilter(data[i].childList, newarr);
        }

        if (data[i].buttonList && data[i].buttonList.length > 0) {
          this.getTreeDataByFilter(data[i].buttonList, newarr);
        }
      }
      return newarr;
    },
    async copyToOtherSpecRole() {
      const roleID = this.systemAddOption.roleID;
      this.$refs.selectSpecRoleDlg.showDlg(roleID);
    },
    // 提交已修改模块树
    async submitModulesHandler() {
      const a = disablePrompt();
      if (a) {
        const list = this.moduleTree;
        const roleID = this.systemAddOption.roleID;
        var newarr = [];
        this.getTreeDataByFilter(list, newarr);
        const rolePermissionDetailList = newarr.map(item => {
          return {
            permissionId: item.permissionId,
            isParentPage: item.isParentPage
          };
        });
        const params = {
          enterpriseId: this.enterpriseId,
          roleId: roleID,
          rolePermissionDetailList
        };
        const res = await priviService.addRolePermission(params);
        if (res.result === "0") this.$message.success("保存成功");
        this.modellist(roleID);
        await this.$store.dispatch("GetModuleList", this.enterpriseId);
      }
    },
    getIndeterminate(row) {
      const { childList, isChecked } = row;
      if (childList && childList.length > 1) {
        for (const item of childList) {
          if (item.isChecked !== isChecked) return true;
        }
      }
      return false;
    },
    // 修改模块和子元素可见性
    setTreeLimit(row) {
      const { setChildrenLimit, setParentLimit } = this;
      const { isChecked, permissionId, pid } = row;
      setChildrenLimit(permissionId, isChecked);
      setParentLimit(pid, isChecked);
    },
    // 修改按钮和子元素可见性
    checkboxChange(row) {
      const { setbuttonParentLimit } = this;
      const { isChecked, pid } = row;
      setbuttonParentLimit(pid, isChecked);
    },
    setbuttonParentLimit(pid, isChecked) {
      if (pid === "0" || !pid) return;
      const { flatModuleList, setParentLimit } = this;
      const module = flatModuleList.find(({ permissionId }) => pid === permissionId);
      if (module && module.buttonList && module.isChecked === 0) {
        // 子元素全部不显示或者有显示的
        let hasShow = false;
        for (const item of module.buttonList) {
          if (item.isChecked > 0) hasShow = true;
        }
        if ((hasShow && isChecked > 0) || (!hasShow && isChecked < 1)) {
          if (module.isChecked !== isChecked) {
            module.isChecked = isChecked;
            setParentLimit(module.pid, isChecked);
          }
        }
      }
    },
    setParentLimit(pid, isChecked) {
      if (pid === "0" || !pid) return;
      const { setParentLimit, flatModuleList } = this;
      const module = flatModuleList.find(({ permissionId }) => pid === permissionId);
      if (module && module.childList) {
        // 子元素全部不显示或者有显示的
        let hasShow = false;
        for (const item of module.childList) {
          if (item.isChecked > 0) hasShow = true;
        }
        if ((hasShow && isChecked > 0) || (!hasShow && isChecked < 1)) {
          if (module.isChecked !== isChecked) {
            module.isChecked = isChecked;
            setParentLimit(module.pid, isChecked);
          }
        }
      }
    },
    setChildrenLimit(permissionId, isChecked) {
      const { flatModuleList, setChildrenLimit } = this;
      const module = flatModuleList.find(module => permissionId === module.permissionId);
      if (module && module.childList && module.childList.length > 0) {
        for (const item of module.childList) {
          item.isChecked = isChecked;
          setChildrenLimit(item.permissionId, isChecked);
        }
      } else if (module && module.buttonList && module.buttonList.length > 0) {
        for (const item of module.buttonList) {
          item.isChecked = isChecked;
          setChildrenLimit(item.permissionId, isChecked);
        }
      }
    },
    empty() {
      this.moduleTree = [];
    },
    setRoleTreeData(data) {
      this.roleType = data.roleType;
    },
    setSystemAddOption(data) {
      this.systemAddOption = data;
    },
    setLoading() {
      this.$emit('setLoading');
    },
    getRoleList() {
      this.$refs.roletree.getRoleList();
    },
    rowStyle() {
      return "height:60px";
    },
    headerStyle() {
      return "background-color: #F7F9FF;color:#2E384D;padding:6px 0;height:54px;border-top:1px solid #EFF0F9";
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        // 指定列号
        return "background: rgba(118, 137, 173, 0.04)";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.projectRole{
  width: 100%;
  height: 100%;
  overflow-x: auto;
}
</style>
<style lang="scss" scoped src="../index.scss" />
